import "./markup-menu";
import svg4everybody from "svg4everybody";
import main from "./components/main";
import menu from "./components/menu";
import Tabs from './components/tabs';
import slider from "./components/slider";
import inputFile from "./components/inputFile";


import homeSlider from "./components/home-slider";
import scroll from "./components/scroll";


document.addEventListener("DOMContentLoaded", () => {
  main();
  const tabs = new Tabs();
  scroll();
  slider();
  inputFile();
  svg4everybody();


  if ($("#home-page").length > 0) {
    homeSlider();
  } else {
    menu();


  }

});


// WEBPACK FOOTER //
// app/scripts/index.js